export const paymentType = {
    'free-panel': {
        name: '/ Grátis'
    },
    'credit-panel': {
        name: '/ Crédito'
    },
    'bonus-panel': {
        name: '/ Bônus'
    },
    'engelink-cash-panel': {
        name: '/ Moedas'
    },
    'mixed-panel': {
        name: '/ Pagamento Misto'
    },
    'free-contact': {
        name: '/ Crédito Assinatura'
    },
    'credit-card': {
        name: '/ Cartão de Crédito'
    },
    'mixed-contact': {
        name: '/ Pagamento Misto'
    }
}
